import { create } from 'zustand'

interface CoinTopUpDialogStore {
  isOpen: boolean
}

export const useCoinTopUpDialogStore = create<CoinTopUpDialogStore>(() => ({
  isOpen: false,
}))

export function openCoinTopUpDialog() {
  useCoinTopUpDialogStore.setState({ isOpen: true })
}

export function closeCoinTopUpDialog() {
  useCoinTopUpDialogStore.setState({ isOpen: false })
}
